import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/saif-dc/Dcastalia/Node JS Projects/ucb/components/research/AllResearch.jsx");
